module.exports = __webpack_public_path__ + "img/logo.f943be81.png";